module.exports = __webpack_public_path__ + "img/meet_icon.3cb9c23.svg";